export default {
    title: 'Сборка / Adaptive',
    scanMark: 'Отсканируйте марку',
    counter: 'Отсканировано: {current} / {total}',
    enableCamera: 'Включить камеру',
    notAllScanned: 'Не все товары отсканированы!',
    'continue': 'Продолжить',
    close: 'Закрыть',
    scanMarkDesktop: 'Товар маркированный, отсканируйте марку!',
    waitChecking: 'Подождите, марка проверяется...',
    good: 'Хорошо',
    scanError: 'Ошибка при проверке марки',
    success: 'Марка успешно прошла проверку! Товар добавлен в заказ',
    additionalInfo: 'Наведите камеру на КИЗ, марка считается автоматически',
    pcError: 'Переключите сканер в режим работы с ПК!',
    cyrillicError: 'Переключите раскладку клавиатуры ПК на английский язык!',
    productIsMarked: 'Товар маркированный',
    noProductMarkMessage: 'Отсканируйте марку. Если её нет — нажмите «Нет марки»',
    collected: 'Собрано: {current} / {total}',
    notMark: 'Нет марки',
    closeScan: 'Закрыть сканирование?',
    notAllProductsCollected: 'Собраны не все товары',
    continueScan: 'Продолжить сканирование',
    addProductWithoutMark: 'Добавить товар без марки?',
    addOneToOrder: 'В заказ добавится 1 шт.',
    add: 'Добавить',
    cancel: 'Отмена',
    scanAgain: 'Отсканировать ещё раз',
    waitAdding: 'Подождите, товар добавляется...',
};